export const CONTENT_TYPE = 'application/json;charset=utf-8';
export const INVALID_URL_ERROR_MESSAGE = 'Invalid URL provided';
export const NETWORK_PROBLEM_ERROR_MESSAGE = 'Network problem';